import { type ClassValue, clsx } from 'clsx';

export function cn(...inputs: ClassValue[]) {
  return clsx(inputs);
}

export function formatTime(seconds: number, showMilliseconds = false): string {
  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;

  if (showMilliseconds) {
    const ms = Math.round((secs % 1) * 100);
    return `${mins}:${Math.floor(secs).toString().padStart(2, '0')}.${ms.toString().padStart(2, '0')}`;
  }

  return `${mins}:${Math.floor(secs).toString().padStart(2, '0')}`;
}

export function formatScore(score: number): string {
  return score.toLocaleString();
}

export { generateId, generateULID } from './ulid';
export { getVersionInfo, formatVersion } from './version';
